import type { StepperProps } from '@moniebook-web/components/widgets/stepper';
import { ArrowDownSLine } from '@moniebook-web/icons-v2/arrows/arrow-down-s-line';
import { CheckLine } from '@moniebook-web/icons-v2/system/check-line';
import { mergeClassNames } from '@moniebook-web/utils';
import { Button, DialogTrigger, Popover } from 'react-aria-components';

export function MobileStepper({ steps, active = 0 }: Readonly<StepperProps>) {
    return (
        <DialogTrigger>
            <div className='flex justify-between'>
                <div className='flex items-center gap-8 text-14 font-medium text-content-body-default'>
                    <span className='flex size-20 flex-shrink-0 items-center justify-center rounded-full bg-content-link-default text-11 font-bold text-white'>
                        {active + 1}
                    </span>
                    {Reflect.get(steps, active).name}
                </div>
                <Button>
                    <ArrowDownSLine className='size-20' />
                </Button>
            </div>
            <Popover className='!left-16 bottom-full flex w-viewport-minus-32 flex-col gap-4 rounded-12 bg-white p-16 shadow-default sm:hidden'>
                {steps.map((step, index) => {
                    return (
                        <div
                            key={step.name}
                            className={mergeClassNames(
                                'flex items-center gap-16 py-8 text-14',
                                step.done &&
                                    '[&_[data-step-indicator]]:bg-feedback-success-filled-default',
                                index === active &&
                                    'font-medium text-content-link-default [&_[data-step-indicator]]:bg-content-link-default',
                            )}>
                            <span
                                data-step-indicator
                                className='flex size-20 flex-shrink-0 items-center justify-center rounded-full bg-content-label-default text-11 font-bold text-white'>
                                {step.done ? (
                                    <CheckLine className='size-12 flex-shrink-0' />
                                ) : (
                                    index + 1
                                )}
                            </span>
                            {step.name}
                        </div>
                    );
                })}
            </Popover>
        </DialogTrigger>
    );
}
